<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="banner管理" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="feedback-form mb-5">
      <div style="margin-top: 1rem;">
        <div class="image-wrapper" v-for="(item, index) in bannerList" :key="index">
          <div class="user-avatar-wrapper">
            <div class="user-avatar">
              <img :src="item.image" @click="openImage(item.image)"/>
              <span @click="dropImage(index)" class="del-btn iconfont">&#xe6d8;</span>
            </div>
          </div>
          <div class="banner-bind">
            <div v-if="item.goods_id" class="banner-bind-info">
              <span class="banner-bind-label">已绑定：</span>
              <span class="banner-bind-name">{{ item.goods_name }}</span>
              <span class="banner-bind-remove" @click="removeGoodsBind(index)">×</span>
            </div>
            <mt-button v-else size="small" type="primary" @click="openGoodsSelect(index)">绑定商品</mt-button>
          </div>
        </div>
        <div v-if="bannerList.length < 3" class="user-avatar iconfont icon-xiangji" @click="uploadInformPic()">
          <div class="center-text">相机/相册</div>
        </div>
        <mt-button size="large" type="primary" class="mt-10" @click="saveBanner">保存</mt-button>
        <p class="banner-tip">最多只能上传3张banner图，可为每张banner绑定商品实现点击跳转</p>
      </div>
      <mt-popup v-model="isshow" popup-transition="popup-fade" class="popup">
        <img :src="showimage" :style="getBannerStyle" @click="isshow = false" />
      </mt-popup>
      <div :style="{ left: showCrop ? 0 : '100%' }" class="crop-wrapper common-popup-wrapper">
        <div class="common-header-wrap">
          <mt-header title="裁剪图片" class="common-header">
            <mt-button slot="left" icon="back" @click="showCrop = false"></mt-button>
            <mt-button slot="right" @click="useCrop">使用</mt-button>
          </mt-header>
        </div>
        <crop
          v-model="crop"
          class="common-popup-content"
          ref="crop"
          defaultImgUrl="png"
          :position="[50, 50, 20, 0]"
          :penBtn="false"
          :revokeBtn="false"
          :rotateBtn="false"
          @imgLoaded="showCrop = true"
        ></crop>
      </div>
      <!-- 商品选择弹窗 -->
      <mt-popup v-model="goodsPopupVisible" position="right" class="common-popup-wrapper" :modal="false">
        <div class="common-header-wrap">
          <mt-header title="选择商品" class="common-header">
            <mt-button slot="left" icon="back" @click="goodsPopupVisible = false"></mt-button>
          </mt-header>
        </div>
        <div class="common-popup-content">
          <div class="common-search">
            <mt-field placeholder="请输入您要搜索的商品" v-model="goodsSearchKeyword" @keyup.enter.native="searchGoods"></mt-field>
            <div class="slot iconfont" @click="searchGoods">&#xe629;</div>
          </div>
          <div v-infinite-scroll="loadMoreGoods" infinite-scroll-disabled="goodsLoading" infinite-scroll-distance="10">
            <div class="select-goods" v-if="goodsSelectList">
              <ul v-if="goodsSelectList.length">
                <li v-for="item in goodsSelectList" v-bind:key="item.goods_commonid" @click="selectGoods(item)">
                  <div class="p-img">
                    <img :src="item.goods_image"/>
                  </div>
                  <div class="p-info">
                    <p class="name">{{ item.goods_name }}</p>
                    <p class="price">{{ item.goods_price }}</p>
                  </div>
                </li>
              </ul>
              <empty-record v-else></empty-record>
            </div>
          </div>
        </div>
      </mt-popup>
    </div>
  </div>
</template>

<script>
import { crop } from 'vue-cropblg'
import { uploadInfoFile, bannerSave, queryDiscount, getGoodsList } from '../../../api/sellerGoods'
import { Toast, Indicator } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  name: 'SellerBanner',
  components: {
    crop,
    EmptyRecord
  },
  data () {
    return {
      crop: {},
      showCrop: false,
      bannerList: [],
      controller: 'Sellergoodsonline',
      controller2: 'Sellerindex',
      showimage: '',
      isshow: false,
      goodsPopupVisible: false,
      currentEditIndex: -1,
      goodsSelectList: [],
      goodsSearchKeyword: '',
      goodsParams: { 'page': 0, 'per_page': 20 },
      goodsLoading: false,
      goodsIsMore: true,
      goodsPageTotal: 1
    }
  },
  computed: {
    getBannerStyle: function () {
      const { width, height } = window.screen
      let itemWidth = width
      let itemHeight = height
      return {
        maxWidth: itemWidth + 'px',
        maxHeight: itemHeight + 'px'
      }
    }
  },
  created () {
    queryDiscount(this.controller2)
      .then((res) => {
        if (res.code === 10000) {
          // 兼容旧数据：字符串转为对象格式
          this.bannerList = (res.result.banner || []).map(item => {
            if (typeof item === 'string') {
              return { image: item, goods_id: null, goods_name: '' }
            }
            return item
          })
        }
      })
      .catch((error) => {
        Toast(error.message)
      })
  },
  methods: {
    // 上传图片
    uploadInformPic () {
      this.crop.changeImage()
    },
    // 剪切
    useCrop () {
      this.crop.getImage('Blob', 'image/png').then((res) => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()
        formdata.append('file', files)
        formdata.append('name', 'file')
        Indicator.open()
        uploadInfoFile(this.controller, formdata)
          .then(res => {
            this.bannerList.push({ image: res.result.url, goods_id: null, goods_name: '' })
            this.showCrop = false
            Indicator.close()
          })
          .catch(function (error) {
            Toast(error.message)
            Indicator.close()
          })
      })
    },
    // 预览照片
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    // 删除照片
    dropImage (delIndex) {
      this.bannerList.splice(delIndex, 1)
      this.$forceUpdate()
    },
    // 保存照片
    saveBanner () {
      bannerSave(this.controller2, this.bannerList)
        .then((res) => {
          Toast(res.message)
          this.$router.go(-1)
        })
        .catch((error) => {
          Toast(error.message)
        })
    },
    // 打开商品选择弹窗
    openGoodsSelect (index) {
      this.currentEditIndex = index
      this.goodsPopupVisible = true
      this.goodsSearchKeyword = ''
      this.goodsParams = { 'page': 0, 'per_page': 20 }
      this.goodsSelectList = []
      this.goodsIsMore = true
      this.loadGoodsList()
    },
    // 移除商品绑定
    removeGoodsBind (index) {
      this.bannerList[index].goods_id = null
      this.bannerList[index].goods_name = ''
      this.$forceUpdate()
    },
    // 搜索商品
    searchGoods () {
      this.goodsParams = { 'page': 0, 'per_page': 20 }
      this.goodsSelectList = []
      this.goodsIsMore = true
      this.loadGoodsList()
    },
    // 加载商品列表
    loadGoodsList () {
      this.goodsLoading = true
      getGoodsList(this.controller, this.goodsParams, this.goodsSearchKeyword, '', '')
        .then(res => {
          this.goodsLoading = false
          if (res.code === 10000) {
            if (res.result.goods_list) {
              this.goodsSelectList = this.goodsSelectList.concat(res.result.goods_list)
            }
            if (!res.result.hasmore) {
              this.goodsIsMore = false
            }
          } else {
            this.goodsIsMore = false
          }
        })
        .catch(error => {
          this.goodsLoading = false
          this.goodsIsMore = false
          Toast(error.message)
        })
    },
    // 加载更多商品
    loadMoreGoods () {
      if (this.goodsLoading || !this.goodsIsMore) return
      this.goodsParams.page++
      this.loadGoodsList()
    },
    // 选择商品
    selectGoods (item) {
      if (this.currentEditIndex >= 0 && this.currentEditIndex < this.bannerList.length) {
        // goods_id 用于跳转商品详情，goods_commonid 用于后端查不到 goods_id 时的回退
        this.bannerList[this.currentEditIndex].goods_id = item.goods_id || item.goods_commonid
        this.bannerList[this.currentEditIndex].goods_name = item.goods_name
      }
      this.goodsPopupVisible = false
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  background: #fff;
}
.image-wrapper {
  width: 100%;
  position: relative;
  text-align: center;
}
.user-avatar-wrapper {
  display: block;
  width: 100%;
  margin-bottom: 0.5rem;
}
.user-avatar-wrapper .del-btn {
  position: absolute;
  bottom: 0.2rem;
  right: 0.2rem;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: center;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border-radius: 50%;
  font-size: 0.8rem;
}
.user-avatar {
  display: block;
  border: 1px solid #eee;
  position: relative;
  width: 16rem;
  height: 6.4rem;
  margin: 0 auto;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
  }
  input {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .center-text {
    padding: 1.8rem 0.2rem 0.2rem 0.2rem;
    font-size: 0.6rem;
  }
}
.user-avatar::before {
  position: absolute;
  font-size: 1.5rem;
  line-height: 7rem;
  left: 50%;
  margin-left: -0.75rem;
  color: rgba(0, 0, 0, 0.5);
}
.label {
  padding: 0.5rem;
  font-size: 0.7rem;
  background: #eee;
  margin-bottom: 0.5rem;
}
.crop-wrapper {
  top: 0;
  left: 100%;
  z-index: 100;
  .common-header {
    position: relative;
    z-index: 10;
  }
}
.banner-bind {
  text-align: center;
  margin: 0.3rem 0;
}
.banner-bind-info {
  display: inline-block;
  background: #f5f7fa;
  border-radius: 4px;
  padding: 0.2rem 0.5rem;
  font-size: 0.65rem;
  color: #666;
}
.banner-bind-label {
  color: #999;
}
.banner-bind-name {
  color: #e93b3d;
  margin-right: 0.3rem;
}
.banner-bind-remove {
  color: #999;
  font-size: 0.8rem;
  cursor: pointer;
  padding: 0 0.2rem;
}
.banner-tip {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: #C0C4CC;
}
.select-goods {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
      display: flex;
      align-items: center;
      padding: 0.5rem;
      border-bottom: 1px solid #eee;
      .p-img {
        width: 3rem;
        height: 3rem;
        flex-shrink: 0;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .p-info {
        flex: 1;
        margin-left: 0.5rem;
        .name {
          font-size: 0.7rem;
          color: #333;
          margin: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .price {
          font-size: 0.65rem;
          color: #e93b3d;
          margin: 0.2rem 0 0 0;
        }
      }
    }
  }
}
</style>
